/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// IEMS

export const GET_BRONZE_MAN_ITEMS = 'GET_BRONZE_MAN_ITEMS';
export const GET_BRONZE_MAN_ITEMS_SUCCESS = 'GET_BRONZE_MAN_ITEMS_SUCCESS';

export const SET_ACQUIRED = 'SET_ACQUIRED';
export const SET_ACQUIRED_SUCCESS = 'SET_ACQUIRED_SUCCESS';

export const CREATE_BRONZE_MAN_ITEM = 'CREATE_BRONZE_MAN_ITEM';
export const CREATE_BRONZE_MAN_ITEM_SUCCESS = 'CREATE_ITEM_SUCCESS';

export const DELETE_BRONZE_MAN_ITEM = 'DELETE_BRONZE_MAN_ITEM';
export const DELETE_BRONZE_MAN_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';

// ENEMIES

export const GET_BRONZE_MAN_ENEMIES = 'GET_BRONZE_MAN_ENEMIES';
export const GET_BRONZE_MAN_ENEMIES_SUCCESS = 'GET_BRONZE_MAN_ENEMIES_SUCCESS';

export const GET_BRONZE_MAN_ENEMY_DATA = 'GET_BRONZE_MAN_ENEMY_DATA';
export const GET_BRONZE_MAN_ENEMY_DATA_SUCCESS = 'GET_BRONZE_MAN_ENEMY_DATA_SUCCESS';

export const CREATE_BRONZE_MAN_ENEMY = 'CREATE_BRONZE_MAN_ENEMY';
export const CREATE_BRONZE_MAN_ENEMY_SUCCESS = 'CREATE_ENEMY_SUCCESS';

export const DELETE_BRONZE_MAN_ENEMY = 'DELETE_BRONZE_MAN_ENEMY';
export const DELETE_BRONZE_MAN_ENEMY_SUCCESS = 'DELETE_ENEMY_SUCCESS';

// ERROR

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const ERROR = 'BRONZE_MAN_ERROR';